import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';

import {
  appendNotification,
  destroyNotificationRequest,
  destroyNotificationSuccess,
} from './notification.actions';
import {
  adapter,
  notificationSelectors,
  type NotificationsState,
} from './notification.interfaces';

export const selectFeature =
  createFeatureSelector<NotificationsState>('notifications');

export const selectFeatureCount = createSelector(
  selectFeature,
  state => state.counter,
);
export const selectAllNotifications = createSelector(
  selectFeature,
  notificationSelectors.selectAll,
);
export const selectTotalNotifications = createSelector(
  selectFeature,
  notificationSelectors.selectTotal,
);
export const selectNotificationIds = createSelector(
  selectFeature,
  notificationSelectors.selectIds,
);
export const selectNotificationEntities = createSelector(
  selectFeature,
  notificationSelectors.selectEntities,
);
export const selectNotificationById = (number: number) =>
  createSelector(
    selectNotificationEntities,
    notifications => notifications[number],
  );

export const initialState: NotificationsState = adapter.getInitialState({
  counter: 0,
});

export const reducer = createReducer(
  initialState,
  on(appendNotification, (state, action) => {
    return adapter.addOne(action, {
      ...state,
      counter: state.counter + 1,
    });
  }),
  on(destroyNotificationRequest, (state, action) => {
    return adapter.updateOne(action, state);
  }),
  on(destroyNotificationSuccess, (state, action) => {
    return adapter.removeOne(action.id, state);
  }),
);
